/**
 * @generated SignedSource<<01ca861cb6fa4d99a661c062f543b0ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type OccurrenceReferenceEnum = "MULTIPLE" | "SALES_ASSOCIATE";
export type SalesAssociateTrackingPositioningRule = "FIRST" | "LAST" | "SAME";
export type SalesAssociateTrackingTreeEnum = "LOST_REASONS" | "POST_OPPORTUNITY" | "PRE_OPPORTUNITY";
import { FragmentRefs } from "relay-runtime";
export type utils_buildOccurrencesTrees$data = {
  readonly items: ReadonlyArray<{
    readonly id?: string;
    readonly name?: string;
    readonly color?: string | null;
    readonly positioningRule?: SalesAssociateTrackingPositioningRule | null;
    readonly type?: OccurrenceReferenceEnum;
  }> | null;
  readonly trees: ReadonlyArray<{
    readonly id: string | null;
    readonly paths: ReadonlyArray<ReadonlyArray<string>>;
    readonly type: SalesAssociateTrackingTreeEnum;
  }> | null;
  readonly " $fragmentType": "utils_buildOccurrencesTrees";
};
export type utils_buildOccurrencesTrees$key = {
  readonly " $data"?: utils_buildOccurrencesTrees$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_buildOccurrencesTrees">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "utils_buildOccurrencesTrees"
};

(node as any).hash = "81c7174d46dcd7f689031bf6eb12fcf1";

export default node;
